<template>
    <div class="objects-row">
        <div :key="object.id" v-for="object in objectsToShow" class="d-inline-block flex-container">
            <store-locator-card @sendGAClick="popupEvent" :object="object" :showSeoCities="showSeoCities"></store-locator-card>
        </div>
        <div v-if="!objectsCounter">
            <span>Sorry, No Stores</span>
        </div>
    </div>
</template>

<script>
import StoreLocatorCard from "./StoreLocatorCard.vue";

export default {
    name: "objects-row",
    props: ["countInRow", "showClass", "objectsToShow", "showSeoCities"],
    components: {
        "store-locator-card": StoreLocatorCard,
    },
    computed: {
        objectsForRow() {
            return Math.ceil(this.objectsToShow.length / this.countInRow);
        },
        objectsCounter() {
            return this.objectsToShow.length > 0;
        },
    },
    methods: {
        filteredObject(i) {
            return this.objectsToShow.slice((i - 1) * this.countInRow, i * this.countInRow);
        },
        popupEvent(payload) {
            this.$emit("sendGAClick", payload);
        },
    },
};
</script>
<style lang="scss" scoped>
.objects-row {
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    flex-wrap: wrap;
}
</style>
